module.exports = __webpack_public_path__ + "assets/img/6.b07bd32d.png";